import React from 'react';
import styled from 'styled-components';
import MaterialIcon from './Icons/MaterialIcon'

const FixedHeader = styled.div`
    position: relative;
`

const CollapseHeader = styled.div`
    position: relative;
    cursor: pointer;
    border-top: 1px solid rgba(0,0,0,0.1);
    border-bottom: 1px solid rgba(0,0,0,0.1);
    height: 48px;
    display: flex;
    align-items: center;
    &:hover {    
        &::after {
            background-color: rgba(0,0,0,0.1);
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
`;

const Collapse = styled(MaterialIcon)`
    font-size: 18px;
    user-select: none;
    vertical-align: middle;
    padding-right:5px;
    vertical-align: middle;
`;

const ActionIcon = styled(MaterialIcon)`
    vertical-align: middle;
    ${p => p.isActive ? "color: " + p.activeColor + ";" : ""}
    user-select: none;
    &:hover{
        cursor: pointer;
        transform: translateY(-1px);
    }
`

const HeaderText = styled.h3`
    font-size: 16px;
    white-space: nowrap;
    min-width: 20px;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
`

const HeaderActions = styled.div`
    margin-right: 5px;
    margin-top: -3px;
    display: flex;
`

interface PillHeaderProps {
    title: string;
    isCollapsible?: boolean;
    isCollapsed?: boolean;
    toggleCollapse?: () => void;
    actions?: IHeaderAction[];
}

export interface IHeaderAction {
    iconName: string;
    action: any;
    active: boolean;
    activeColor: string;
    toolTip: string;
    show: boolean;
}

const PillHeaderComponent = ({ title, isCollapsible, isCollapsed, toggleCollapse, actions }: PillHeaderProps) => {
    return (
        isCollapsible ? <CollapseHeader isCollapsible = {isCollapsible} isCollapsed = {isCollapsed} onClick = {() => { toggleCollapse && toggleCollapse() }}>
            <HeaderText>
                <Collapse>{isCollapsed ? "keyboard_arrow_down" : "keyboard_arrow_up"}</Collapse>
                {title}
            </HeaderText>
            {
                actions && <HeaderActions>
                    {actions.filter(action => action.show).map(action => <ActionIcon title={action.toolTip} isActive={action.active} activeColor={action.activeColor} key={action.iconName} onClick={() => action.action()}>{action.iconName}</ActionIcon>)}
                </HeaderActions>
            }
        </CollapseHeader> :
            <FixedHeader>
                <HeaderText>
                    {title}
                </HeaderText>
                {
                    actions && <HeaderActions>
                        {actions.filter(action => action.show).map(action => <ActionIcon title={action.toolTip} isActive={action.active} activeColor={action.activeColor} key={action.iconName} onClick={() => action.action()}>{action.iconName}</ActionIcon>)}
                    </HeaderActions>
                }
        </FixedHeader>
    );
}

export default PillHeaderComponent